var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaceDashboardDashboardSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44444 13C1.04722 13 0.707055 12.8587 0.423944 12.5761C0.141315 12.2929 0 11.9528 0 11.5556V1.44444C0 1.04722 0.141315 0.707055 0.423944 0.423944C0.707055 0.141315 1.04722 0 1.44444 0H5.77778V13H1.44444ZM7.22222 13V6.5H13V11.5556C13 11.9528 12.8587 12.2929 12.5761 12.5761C12.2929 12.8587 11.9528 13 11.5556 13H7.22222ZM7.22222 5.05556V0H11.5556C11.9528 0 12.2929 0.141315 12.5761 0.423944C12.8587 0.707055 13 1.04722 13 1.44444V5.05556H7.22222Z",
    fill: "#FFA177"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceDashboardDashboardSelected);
export default __webpack_public_path__ + "static/media/space_dashboardDashboardSelected.6aa29d1d1e06cf424bb2046db9179dcf.svg";
export { ForwardRef as ReactComponent };